import {today} from "@/Utilites/timerHelper";
import {resolveSessionLogDate} from "@/services/timerV1Mapper";

/**
 * Short hint when an active session belongs to a work day that is not calendar today.
 */
export function timerV1CrossDayHint(v1Session, timerLogsList) {
  if (!v1Session || v1Session.status !== "active") return "";
  const logDate = resolveSessionLogDate(v1Session, timerLogsList);
  const todayStr = today();
  if (!logDate || logDate === todayStr) return "";
  return `Timer running on ${logDate} (not today). Hours stay on that day if you stop after midnight.`;
}
